module.exports = __webpack_public_path__ + "static/leafRight-48287caf7d566e20739e203e642310fa.png";